var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "106.1px",
    height: "106.289px",
    viewBox: "74.65 17.75 106.1 106.289",
    enableBackground: "new 74.65 17.75 106.1 106.289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 38.5,
    fill: "#8DC63F",
    width: 66,
    height: 65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-plus",
    fill: "#FFFFFF",
    d: "M127.5,17.75c-29.409,0-53.25,23.841-53.25,53.25s23.841,53.25,53.25,53.25 s53.25-23.841,53.25-53.25C180.718,41.604,156.896,17.782,127.5,17.75z M154.125,75.438c0,2.451-1.986,4.438-4.438,4.438h-13.313 v13.313c0,2.451-1.985,4.438-4.438,4.438h-8.875c-2.451,0-4.438-1.986-4.438-4.438V79.875H105.31c-2.451,0-4.438-1.986-4.438-4.438 v-8.875c0-2.451,1.987-4.438,4.438-4.438h13.313V48.813c0-2.451,1.987-4.438,4.438-4.438h8.875c2.451,0,4.438,1.987,4.438,4.438 v13.313h13.313c2.451,0,4.438,1.987,4.438,4.438V75.438z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus_green.e989f8944df910f60bd532523bc933a6.svg";
export { ForwardRef as ReactComponent };